//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SketchGeometryBuilder.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/Expression.js";
let d=[[[1,"Angle",0,"Expression",0],[1,"Length",0,"Expression",0],[0,"LockAngle",1,0],[0,"LockLength",1,0],[0,"LockRelativeAngle",1,0],[1,"RelativeAngle",0,"Expression",0]],[[["startPoint"],"SetStartPoint",{},1,0],[["midpoint"],"SetMidpoint",{},1,0],[["endPoint"],"SetEndPoint",{},1,0],[["startPoint"],"SnapStartPoint",{},1,0],[["midpoint"],"SnapMidpoint",{},1,0],[["endPoint"],"SnapEndPoint",{},1,0]],[]];
SPLM.SketchLineBuilder = class extends SPLM.SketchGeometryBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchLineBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;